let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("izz0R")).then(() => parcelRequire('7rVZ2'));